import { createSlice } from "@reduxjs/toolkit";

const initialPksResidentialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  pksResidentialForEdit: undefined,
  pksResidentialForExport: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const pksResidentialSlice = createSlice({
  name: "pksResidential",
  initialState: initialPksResidentialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    pksResidentialFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    pksResidentialAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    pksResidentialExportFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.pksResidentialForExport = entities;
    },
    pksResidentialCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.pksResidential.push(action.payload.pksResidential);
    },
    pksResidentialDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.pksResidential.filter(
        (el) => el.pksResidential_id !== action.payload.id
      );
    },
    getPksResidential: (state, action) => {
      state.actionsLoading = false;
      state.pksResidentialForEdit = action.payload.pksResidentialForEdit;
      state.error = null;
    },
    getExportPksResidential: (state, action) => {
      state.actionsLoading = false;
      if (action.payload.pksResidentialForExport === undefined) {
        state.pksResidentialForExport = [];
      } else {
        state.pksResidentialForExport.push(
          action.payload.pksResidentialForExport
        );
      }
      state.error = null;
    },
    // updateProduct
    pksResidentialUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.pksResidential = state.entities.pksResidential.map(
        (entity) => {
          if (
            entity.pksResidential_id ===
            action.payload.pksResidential.pksResidential_id
          ) {
            return action.payload.pksResidential;
          }
          return entity;
        }
      );
    },
  },
});
